import { SET_INSPECTIONS } from "../../../constants";

export const setInspections = (insps: any = []) => ({
  type: SET_INSPECTIONS,
  payload: insps,
});
